import React from 'react';
import Logo from '../../assets/svg/logo.svg';

const NavbarIconMobile = () => {
  return (
      <div className="flex items-center pt-4 max-h-6">
        <img src={Logo} alt="Logo" className="w-14 h-auto" />
      </div>
  );
};

export default NavbarIconMobile;